import React from 'react'
import { Image } from 'newComponents'
import './styles.scss'
import Challenge from '../../images/menu/resources/Code_v2.svg'
import Solution from '../../images/case-studies/Toggle2.png'
import Results from '../../images/menu/product/CaseStudies.svg'

const Timeline = (props) => {
  const { data } = props
  const { companyName, items: timelineContents } = data

  return (
    <div className="bg-gradient">
      <div className="container timeline-container">
        <h2>{companyName} Timeline</h2>

        {timelineContents && (
          <div className="timeline-timelines">
            {timelineContents.map((content) => {
              let img
              switch (content.timeline) {
                case 'Solution':
                  img = Solution
                  break
                case 'Results':
                  img = Results
                  break
                default:
                  img = Challenge
              }
              return (
                <div key={content.timeline} className={`timeline ${content.timeline}`}>
                  <div className="timeline-icon">
                    <Image image={img} />
                  </div>
                  <div className="timeline-contents">
                    <h4>{content.timeline}</h4>
                    <div
                      className="timeline-content"
                      dangerouslySetInnerHTML={{ __html: content.timeline_content.html }}
                    />
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}

export default Timeline
